import { render } from "./AlarmItem.vue?vue&type=template&id=21cb610e&scoped=true&ts=true"
import script from "./AlarmItem.vue?vue&type=script&lang=ts"
export * from "./AlarmItem.vue?vue&type=script&lang=ts"

import "./AlarmItem.vue?vue&type=style&index=0&id=21cb610e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cb610e"]])

export default __exports__